import React from 'react';
import getFirstAvatarUrl from '../../utils/avatar';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import { useGuestFootprints } from '../../hooks/useQueries';
import Spinner from '../ui/Spinner';

interface FootprintItem {
  id: number;
  avatar?: string;
  nickname?: string;
  cast_id: number;
  updated_at?: string;
  created_at?: string;
}


const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const FootprintsSection: React.FC<{ hideLoading?: boolean }> = ({ hideLoading = false }) => {
  const { user } = useUser();
  const navigate = useNavigate();
  const { data: footprintsData, isLoading: loading, error } = useGuestFootprints(user?.id || 0);
  const footprints = footprintsData?.history || [];

  const handleAvatarClick = (castId: number) => {
    console.log('Avatar clicked for cast ID:', castId);
    if (!castId) {
      console.error('Cast ID is missing or invalid');
      return;
    }
    try {
      navigate(`/cast/${castId}`);
    } catch (error) {
      console.error('Navigation error:', error);
    }
  };

  if (loading && !hideLoading) {
    return <Spinner />;
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center py-12 px-4 bg-primary rounded-lg border border-secondary">
        <h2 className="text-lg font-bold text-center mb-2 text-white">エラーが発生しました</h2>
        <p className="text-sm text-white text-center">足あとの取得に失敗しました</p>
      </div>
    );
  }

  if (!footprints.length) {
    return (
      <div className="flex flex-col items-center justify-center py-12 px-4 rounded-lg">
        <h2 className="text-lg font-bold text-center mb-2 text-white">まだ誰もあなたのプロフィールを見ていません</h2>
        <p className="text-sm text-white text-center">キャストがあなたのプロフィールを訪れるとここに表示されます</p>
      </div>
    );
  }

  return (
    <div className="rounded-lg shadow p-4 py-8 mb-4">
      <h2 className="font-bold text-lg mb-2 text-white">足あと（あなたのプロフィールを見たキャスト）</h2>
      {footprints.map((item: FootprintItem) => (
        <div key={item.id} className="bg-white/10 rounded-lg shadow p-3 border border-secondary mb-2">
          <div className="flex space-x-4 items-center">
            <div className="w-16 h-16">
              <img
                src={getFirstAvatarUrl(item.avatar)}
                alt={item.nickname || ''}
                className="w-full h-full object-cover rounded border border-secondary cursor-pointer hover:opacity-80 transition-opacity"
                onClick={() => handleAvatarClick(item.cast_id)}
                onError={(e) => {
                  e.currentTarget.src = '/assets/avatar/female.png';
                }}
              />
            </div>
            <div className="flex-1">
              <span className="font-medium text-white">{item.nickname || ''}</span>
              <div className="text-xs text-white mt-1">{new Date(item.updated_at || item.created_at || '').toLocaleString()}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FootprintsSection; 